/**
 * Metadati <head> dell'area Sanità. Lo script inline di public/index.html li applica
 * prima del primo paint quando si apre direttamente /sanitario*; questa funzione li
 * applica (e li ripristina) quando si entra navigando dentro la SPA.
 * I valori devono coincidere con quelli dello script inline (c'è un test).
 */
export const SANITARIO_MANIFEST = "/sanita/manifest.webmanifest";
export const SANITARIO_VIEWPORT = "width=device-width, initial-scale=1, viewport-fit=cover";
export const SANITARIO_THEME = "#901030";
export const SANITARIO_APPLE_ICON = "/sanita/icons/sanita-apple-touch-180.png";
export const SANITARIO_TITLE = "Sanità";

export function isSanitarioPath(p) {
  const path = String(p || "");
  return path === "/sanitario" || path.startsWith("/sanitario/") || path === "/sanitario-login";
}

function setAttr(sel, attr, val, saved) {
  const el = document.head.querySelector(sel);
  if (!el) return;
  saved.push([el, attr, el.getAttribute(attr)]);
  el.setAttribute(attr, val);
}

/** Applica i metadati Sanità; restituisce una funzione che ripristina quelli originali. */
export function applySanitarioHead() {
  if (typeof document === "undefined") return () => {};
  if (document.documentElement.getAttribute("data-app") === "sanitario" && document.head.querySelector('meta[data-sanitario="1"]')) {
    return () => {};
  }
  const saved = [];
  setAttr('link[rel="manifest"]', "href", SANITARIO_MANIFEST, saved);
  setAttr('meta[name="viewport"]', "content", SANITARIO_VIEWPORT, saved);
  setAttr('meta[name="theme-color"]', "content", SANITARIO_THEME, saved);
  setAttr('meta[name="apple-mobile-web-app-title"]', "content", SANITARIO_TITLE, saved);
  setAttr('meta[name="application-name"]', "content", SANITARIO_TITLE, saved);
  setAttr('link[rel="apple-touch-icon"]', "href", SANITARIO_APPLE_ICON, saved);
  const mark = document.createElement("meta");
  mark.setAttribute("data-sanitario", "spa");
  mark.name = "sanitario-pwa";
  mark.content = "1";
  document.head.appendChild(mark);
  document.documentElement.setAttribute("data-app", "sanitario");
  return () => {
    for (let i = saved.length - 1; i >= 0; i -= 1) {
      const [el, attr, val] = saved[i];
      if (val === null) el.removeAttribute(attr);
      else el.setAttribute(attr, val);
    }
    mark.remove();
    document.documentElement.removeAttribute("data-app");
  };
}
